<template lang="pug">
div
  index-page(@set-loading="setLoading", :parentData="{ grid, path, grid_key, report_class }")

  ui-prompts(:parentData="{ areas_key: grid }")
</template>

<script>
import indexPage from "../../shared/indexPage";
import uiPrompts from "../../shared/ui_prompts/index.vue";

export default {
  components: {
    indexPage,
    uiPrompts,
  },
  data: function () {
    return {
      grid: "companies",
      report_class: "company",
      path: this.$store.state.paths["company"],
      grid_key: "data",
    };
  },

  beforeMount() {
    this.$emit("expand-class", { val: false, class: "" });
  },

  methods: {
    setLoading(val) {
      this.$emit("set-loading", val);
    },
  },
};
</script>

<style lang="scss"></style>
